import '../AMap/AMap.less';
import '../BMap/Map.less';
import '../GMap/Map.less';
import '../OMap/Map.less';
import '../TMap/TMap.css';

import '../Map.css';